import './Filters.scss'
import { Filter } from './components/Filter/Filter'
import { useContext, useMemo } from 'react'
import FiltersContext from '../../../Context/FiltersContext'
import { IProyectos } from '../../data/data.model'

import { useTranslation } from 'react-i18next'

interface FiltersProps {
  data: IProyectos[]
  // lang: string
}

export const Filters = ({ data }: FiltersProps) => {
  const { t }: any = useTranslation()
  const { filterCategories, filtersSelected } = useContext(FiltersContext)

  // Get options
  const extractFilterOptions = (keyToFind: string): string[] => {
    const dataSet = new Set<string>()
    data.forEach((project: any) => {
      if (project[keyToFind]) {
        if (Array.isArray(project[keyToFind])) {
          project[keyToFind].forEach((keyEle: string) => {
            if (
              !!keyEle &&
              keyEle !== 'No disponible' &&
              keyEle !== 'Not available' &&
              keyEle !== 'Não disponível'
            )
              dataSet.add(keyEle.trim())
          })
        } else {
          if (
            project[keyToFind] !== 'No disponible' &&
            project[keyToFind] !== 'Not available' &&
            project[keyToFind] !== 'Não disponível'
          ) {
            dataSet.add(project[keyToFind])
          }
        }
      }
    })
    return Array.from(dataSet)
  }

  // Get Filters -> modificar para usar la data quemada con ids (falta la data actualizada)
  const filters = useMemo(() => {
    return filterCategories.map(
      (category: { name: string; filterKey: string }) => {
        let options: { label: string; value: any }[] = []

        switch (category.filterKey) {
          case 'id_pais':
            options.push(
              ...[
                { label: t('countries.brasil'), value: 'brasil' },
                { label: t('countries.colombia'), value: 'colombia' },
                { label: t('countries.peru'), value: 'peru' },
              ]
            )
            break
          case 'departamento':
            const countries = filtersSelected.id_pais.map(
              (country: { label: string; value: string }) => country.value
            )
            // Si el país seleccionado es "Todos", incluir todos los departamentos
            const pDepartments = countries.includes(t('filters.all'))
              ? data.map((project) => project.departamento).filter(Boolean)
              : data
                  .filter((project) => countries.includes(project.id_pais))
                  .map((project) => project.departamento)
                  .filter(Boolean)

            const dataSet = new Set<string>()
            pDepartments.forEach((pDepartment: any[]) => {
              pDepartment.forEach((keyEle: string) => {
                if (!!keyEle && keyEle) dataSet.add(keyEle.trim())
              })
            })

            options.push(
              // ...Array.from(new Set(...departments)).map((dept) => ({
              ...Array.from(dataSet).map((dept) => ({
                label: dept,
                value: dept,
              }))
            )
            break

          case 'id_tipo_territorio':
            options.push(
              ...extractFilterOptions('id_tipo_territorio').map(
                (id_tipo_territorio) => ({
                  label: t(`territory_type.${id_tipo_territorio}`),
                  value: id_tipo_territorio,
                })
              )
            )
            break

          case 'id_bioma':
            options.push(
              ...extractFilterOptions('id_bioma').map((id_bioma) => ({
                label: t(`biomas.${id_bioma}`),
                value: id_bioma,
              }))
            )
            break

          case 'amazonia':
            options.push(
              { label: 'Si', value: 'Si' },
              { label: 'No', value: 'No' }
            )
            break

          case 'empresas_desarrolladoras':
            options.push(
              ...extractFilterOptions('empresas_desarrolladoras').map(
                (empresa) => ({
                  label: empresa,
                  value: empresa,
                })
              )
            )
            break

          case 'estandar_certificacion': //key para el certificador
            options.push(
              ...extractFilterOptions('estandar_certificacion').map(
                (certificador) => ({
                  label: certificador,
                  value: certificador,
                })
              )
            )
            break

          case 'verificador': // Key para el auditor
            options.push(
              ...extractFilterOptions('verificador').map((verificador) => ({
                label: verificador,
                value: verificador,
              }))
            )
            break

          default:
            break
        }

        options = [
          { label: t('filters.all'), value: t('filters.all') },
          ...options.sort((a: any, b: any) => a.label.localeCompare(b.label)),
        ]

        return (
          <Filter
            key={category.name}
            filterKey={category.filterKey}
            category={category.name}
            options={options}
          />
        )
      }
    )
  }, [data, filterCategories, filtersSelected])

  return (
    <>
      {/* <div className="country-filters_container">
        <CountryFilters />
      </div> */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        {filters}
      </div>
    </>
  )
}
